<template>
  <div>
    <div v-if="isloaded && !iserror">
      <div class="p-4 w-100" v-if="rows.length == 0">
        <div
          class="d-flex flex-item justify-content-center mt-3 mx-auto no-results"
        >
          <svg
            width="100"
            height="150"
            viewBox="0 0 189 198"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M169.105 0H69.6302C58.6582 0 49.7353 8.8803 49.7353 19.8V75.1014L2.91249 121.701C1.52174 123.085 0.574676 124.849 0.191026 126.769C-0.192624 128.689 0.00436646 130.68 0.757093 132.488C1.50982 134.297 2.78448 135.843 4.41995 136.931C6.05541 138.019 7.97824 138.6 9.94536 138.6V188.1C9.94536 190.726 10.9934 193.244 12.8589 195.1C14.7244 196.957 17.2546 198 19.8928 198H179.053C181.691 198 184.221 196.957 186.086 195.1C187.952 193.244 189 190.726 189 188.1V19.8C189 8.8803 180.077 0 169.105 0ZM89.5252 178.2H29.8403V122.899L59.6828 93.1986L89.5252 122.899V178.2ZM169.105 178.2H109.42V138.6C111.389 138.604 113.316 138.026 114.954 136.939C116.593 135.852 117.87 134.305 118.623 132.494C119.377 130.684 119.573 128.691 119.186 126.769C118.8 124.848 117.849 123.083 116.453 121.701L69.6302 75.1014V19.8H169.105V178.2Z"
            />
            <path
              d="M89.6 39H109.4V59H89.6V39ZM129.2 39H149V59H129.2V39ZM129.2 79.31H149V99H129.2V79.31ZM129.2 119H149V139H129.2V119ZM50 129H69.8V149H50V129Z"
            />
          </svg>
        </div>
        <div
          style="width: 80%; max-width: 600px; text-align: center; margin: auto"
        >
          <i class="fas fa-exclamation-triangle"></i> Sorry, we didn't found any
          comparisons property record.<br /><a href="/"
            >Browse listing and compare now</a
          >
        </div>
      </div>
      <div class="d-flex flex-wrap uni-max-sm my-3" v-else>
        <div v-for="(row, index) in rows" :key="index" class="comparison-grid">
          <div class="header">
            <a :href="`/comparisons/${row.id}/`"
              ><h3>
                Comparing {{ row.comparison_properties.length }}
                {{ row.category }} properties for {{ row.listing_type }}
              </h3></a
            >
            <div class="actions-btns">
              <a href="#" @click="toggleShare($event, row.id)" class="share"
                ><svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="48" height="48" rx="24" fill="#282828"></rect>
                  <path
                    d="M30.3999 29.0601C29.5897 29.0601 28.8588 29.3873 28.3045 29.9141L20.7039 25.3074C20.7628 25.0573 20.7999 24.7965 20.7999 24.5305C20.7999 24.2644 20.7628 24.005 20.7039 23.7549L28.2239 19.1934C28.8127 19.7699 29.591 20.0911 30.3999 20.0913C32.165 20.0913 33.5999 18.6001 33.5999 16.7656C33.5999 14.9312 32.165 13.4399 30.3999 13.4399C28.6348 13.4399 27.1999 14.9312 27.1999 16.7656C27.1999 17.0317 27.237 17.2924 27.2959 17.5412L19.7759 22.1027C19.1868 21.5268 18.4087 21.2057 17.5999 21.2048C15.8348 21.2048 14.3999 22.696 14.3999 24.5305C14.3999 26.3649 15.8348 27.8562 17.5999 27.8562C18.4088 27.856 19.1871 27.5348 19.7759 26.9583L27.3765 31.565C27.3206 31.8028 27.2918 32.0466 27.2908 32.2914C27.291 32.9301 27.4735 33.5543 27.8151 34.0853C28.1567 34.6162 28.6421 35.03 29.2099 35.2743C29.7777 35.5186 30.4025 35.5825 31.0052 35.4578C31.608 35.3331 32.1616 35.0256 32.5962 34.5739C33.0308 34.1223 33.3267 33.5469 33.4467 32.9205C33.5666 32.2941 33.5052 31.6447 33.2701 31.0546C33.0351 30.4645 32.6369 29.96 32.126 29.605C31.6152 29.25 31.0145 29.0604 30.3999 29.0601Z"
                    fill="#515151"
                  ></path></svg
              ></a>
              <a
                href="#"
                @click="deleteComparison($event, row.id)"
                class="delete"
              >
                <svg
                  width="800px"
                  height="800px"
                  viewBox="0 -0.5 21 21"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <title>delete [#1487]</title>
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="Dribbble-Light-Preview"
                      transform="translate(-179.000000, -360.000000)"
                      fill="#000000"
                    >
                      <g
                        id="icons"
                        transform="translate(56.000000, 160.000000)"
                      >
                        <path
                          d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
                          id="delete-[#1487]"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          </div>
          <div class="px-3">
            <div class="row">
              <div
                v-for="(c_prop, index) in row.comparison_properties"
                :key="index"
                class="p4-propcard"
              >
                <a :href="'/' + row.listing_type + '/' + c_prop.property.slug">
                  <div class="p4-propimg">
                    <img
                      v-lazy="c_prop.property.featured_photo.medium.url"
                      :alt="c_prop.property.id"
                    />
                  </div>
                </a>
                <div class="p4-propbody">
                  <a
                    :href="
                      '/' +
                      row.listing_type.toLowerCase() +
                      '/' +
                      c_prop.property.slug
                    "
                    class="p4-proptitle mb-2"
                  >
                    <span class="text-capitalize">{{
                      c_prop.property.property_type_name.toLowerCase()
                    }}</span>
                    <span
                      v-if="
                        c_prop.property.property_type_name &&
                        c_prop.property.project
                      "
                    >
                      at
                    </span>
                    <span class="text-capitalize">
                      {{ c_prop.property.project.toLowerCase() }}</span
                    >
                    <span v-if="c_prop.property.area && c_prop.property.project"
                      >,
                    </span>
                    <span class="text-capitalize">
                      {{ c_prop.property.area.toLowerCase() }}</span
                    >
                  </a>
                  <div class="d-flex flex-nowrap w-100 align-items-center">
                    <div
                      class="d-flex flex-nowrap p4-pricepad align-items-center"
                    >
                      <div
                        v-if="row.listing_type == 'SALE'"
                        class="p4-propprice text-nowrap"
                      >
                        RM {{ addComma(c_prop.property.sale_selling_price) }}
                      </div>
                      <div
                        v-else-if="row.listing_type == 'RENT'"
                        class="p4-propprice text-nowrap"
                      >
                        RM {{ addComma(c_prop.property.monthly_rental_price) }}
                      </div>
                      <div
                        v-else-if="row.listing_type == 'AUCTION'"
                        class="p4-propprice text-nowrap"
                      >
                        RM {{ addComma(c_prop.property.auction_reserve_price) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="date">Created at: {{ row.created_at }}</div>
          <!-- share modal -->
          <share-btn
            :index="row.id"
            @remove="hideShare"
            :manualToggle="share_target"
            :title="`Check out this ${row.comparison_properties.length} ${row.category} available for ${row.listing_type} | Shijie Property 世界地產`"
            :text="`Check out this ${row.comparison_properties.length} ${row.category} available for ${row.listing_type} at Shijie Property 世界地產`"
            :label="`Check out this ${row.comparison_properties.length} ${row.category} available for ${row.listing_type}`"
            :url="`/comparisons/${row.id}`"
          ></share-btn>
        </div>

        <!-- table pagination -->
        <div
          v-if="rows.length != 0 && isloaded"
          class="df-mn flex-row flex-wrap my-5 px-3 w-100"
          style="font-size: 14px"
        >
          <nav
            v-if="rows.length != 0"
            aria-label="pager"
            role="navigation"
            class="pagy-bootstrap-nav align-self-center"
          >
            <ul class="pagination d-flex flex-wrap justify-content-center">
              <li class="page-item prev" v-show="pagy.prev">
                <a
                  @click="changePage(pagy.page - 1)"
                  aria-label="previous"
                  class="page-link"
                >
                  <i class="fas fa-arrow-left"></i>
                </a>
              </li>
              <li
                v-for="(v, index) in pagy.series"
                :key="index"
                v-show="pagy.series"
                :class="{ active: index + 1 == pagy.page }"
                class="page-item"
              >
                <a
                  v-if="index != 'gap'"
                  @click="changePage(index + 1)"
                  class="page-link"
                  >{{ index + 1 }}</a
                >
                <div v-else class="page-link">...</div>
              </li>
              <li class="page-item next" v-show="pagy.next">
                <a
                  @click="changePage(pagy.page + 1)"
                  rel="next"
                  aria-label="next"
                  class="page-link"
                >
                  <i class="fas fa-arrow-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-center py-4 uni-max"
      v-else-if="!isloaded && !iserror"
    >
      <div class="text-center my-3 t-text" style="padding-bottom: 300px">
        <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "comparison-list",
  data() {
    return {
      isloaded: true,
      iserror: false,
      curpage: 1,
      rows: [],
      pagy: [],
      share_target: "",
    };
  },
  mounted() {
    this.getComparisons();
  },
  methods: {
    toggleShare: function (e, id) {
      if (e) {
        e.preventDefault();
      }
      this.share_target = id;
    },
    hideShare: function () {
      this.share_target = "";
    },
    deleteComparison: function (e, id) {
      e.preventDefault();
      let vm = this;
      this.$http
        .delete(`/api/v1/user/comparisons/${id}`)
        .then((res) => {
          vm.$toast.success("Property comparison record deleted successful", {
            position: "top-right",
          });
          vm.getComparisons();
        })
        .catch((error) => {
          vm.$toast.warning(
            "Property comparison record failed delete.. Please try again",
            {
              position: "top-right",
            }
          );
        });
    },
    changePage(newPage) {
      if (newPage != this.pagy.page) {
        this.curpage = newPage;
        this.getComparisons();
      }
    },
    getComparisons: function () {
      let vm = this;
      vm.isloaded = false;
      vm.iserror = false;
      this.$http
        .get(`/api/v1/user/comparisons?page=${this.curpage}`)
        .then((response) => {
          vm.rows = response.data.comparisons;
          const headers = response.headers;
          const pagy = {
            prev: headers["current-page"] != 1,
            next: headers["current-page"] != headers["total-pages"],
            series: new Array(parseInt(headers["total-pages"])),
            page: parseInt(headers["current-page"]),
          };
          console.log(new Array(headers["total-pages"]));
          vm.pagy = pagy;
          vm.isloaded = true;
        })
        .catch((error) => {
          vm.rows = [];
          vm.pagy = [];
          vm.iserror = true;
          vm.isloaded = true;
          console.log(error);
          console.log("change page");
        });
    },
    addComma: function (num) {
      var num_parts = num.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    },
  },
};
</script>

<style scope>
.comparison-grid {
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  background: #1c1c1c;
  margin: 1rem;
}
.comparison-grid:first-child {
  margin-top: 3rem;
}
.comparison-grid .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.comparison-grid .header h3 {
  font-size: 18px;
  margin-bottom: 1.5rem;
}
.comparison-grid .header .actions-btns {
  display: flex;
  align-items: center;
  gap: 7px;
}
.comparison-grid .header .actions-btns .share svg {
  height: 35px;
}
.comparison-grid .header .actions-btns .delete svg {
  width: 40px;
  background: #282828;
  border-radius: 100%;
  height: 40px;
  padding: 8px;
}
.comparison-grid .header .actions-btns .delete:hover svg {
  background: #d80000;
}
.comparison-grid .header .actions-btns .delete svg path {
  fill: #515151;
}
.comparison-grid .header .actions-btns .share:hover svg path,
.comparison-grid .header .actions-btns .delete:hover svg path {
  fill: #0f0f0f;
}

.comparison-grid .header .actions-btns .share:hover svg rect {
  fill: #d80000;
}
.comparison-grid .date {
  text-align: right;
  color: gray;
}
.comparison-grid .p4-propcard {
  width: calc(22% - 20px);
}
@media screen and (max-width: 600px) {
  .comparison-grid .p4-propcard {
    width: calc(50% - 20px);
  }
}
</style>